import { config } from '@/config';

/**
 * Hook to check if the app is running in preview mode.
 * Preview mode is enabled when accessed via the preview domain (portal-preview.*).
 *
 * Use this hook to conditionally show/hide features that are not yet ready for public consumption.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const isPreviewMode = usePreviewMode();
 *
 *   return (
 *     <div>
 *       <h1>Welcome</h1>
 *       {isPreviewMode && <ExperimentalFeature />}
 *     </div>
 *   );
 * }
 * ```
 */
export function usePreviewMode(): boolean {
  return config.isPreviewMode;
}
